import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { FeatureState, SiteDeploymentType } from '@myrtls/api-interfaces';
import { environment } from '../../../environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector:
        'myrtls-menu-item[icon][title][category][expanded][state][active][badge][about]',
    templateUrl: './menu-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IconComponent, MatTooltipModule],
})
export class MenuItemComponent {
    @Input() category!: string;
    @Input() title!: string;
    @Input() icon!: string;
    @Input() expanded!: boolean;
    @Input() state!: FeatureState;
    @Input() active!: boolean;
    @Input() badge!: boolean;
    @Input() about!: string;

    private onprem = environment.deployment === SiteDeploymentType.ON_PREM;

    FeatureState = FeatureState;

    getMenuItemTooltip(
        category: string | null,
        title: string,
        state: FeatureState,
    ) {
        if (state === FeatureState.ENABLED) {
            return category ? `${category} - ${title}` : `${title}`;
        }

        return category
            ? `${category} - ${title}   [${this.getIconTooltip(state)}]`
            : `${title}   [${this.getIconTooltip(state)}]`;
    }

    getIconTooltip(state: FeatureState) {
        switch (state) {
            case FeatureState.LOCKED:
                return 'License is not sufficient for this feature. Click to learn more...';
            case FeatureState.EXPIRED:
                return 'License has expired for this feature. Click to learn more...';
            case FeatureState.OTHER_DEPLOYMENT:
                return this.onprem
                    ? 'This feature is only available in CLOUD instance of myRTLS. Click to learn more...'
                    : 'This feature is currently available in ON-PREMISE instance of myRTLS. Click to learn more...';
            case FeatureState.BLOCKED:
                return 'This feature is blocked. Click to learn more...';
            case FeatureState.NOT_PERMITTED:
                return 'You do not have appropriate permissions to access this feature. Click to learn more...';
        }

        return '';
    }

    iconClick(event: Event, link: string): void {
        if (link) {
            this.redirect(link);
        }

        event.stopPropagation();
    }

    redirect(link: string): void {
        window.open(link, '_blank');
    }

    getIcon(state: FeatureState) {
        switch (state) {
            case FeatureState.LOCKED:
                return 'lock';
            case FeatureState.EXPIRED:
                return 'lock_clock';
            case FeatureState.OTHER_DEPLOYMENT:
                return 'vpn_lock';
            case FeatureState.BLOCKED:
                return 'block';
            case FeatureState.NOT_PERMITTED:
                return 'lock_person';
        }

        return '';
    }
}
